import { Boolean, Number, Partial, Record, String } from "runtypes";
export const ShareableProgress = Record({
  id: String,
  bits: String,
  watched: Number,
  total: Number,
  percentage: Number,
  completed: Boolean,
  duration: Number
}).And(
  Partial({
    semester: String
  })
);
export const SHAREABLE_INTERVAL = 8;
export const COMPLETED_THRESHOLD = 0.9;
//# sourceMappingURL=progress.js.map
